import { render } from "./TransactionChart.vue?vue&type=template&id=efe22110"
import script from "./TransactionChart.vue?vue&type=script&lang=ts"
export * from "./TransactionChart.vue?vue&type=script&lang=ts"
script.render = render

export default script